import * as React from 'react';
import { Dispatch } from 'redux';

import { BaseApiPatchRequest } from '../generic/baseApiPatchRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class ConvertToUnknownParticipantRequest extends BaseApiPatchRequest<
  {},
  EntityNormalizers.NormalizedEntityArray<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(participantId: string, component: React.Component, dispatch: Dispatch) {
    super({}, component, dispatch);
    this.path = `/participants/${participantId}/convert-to-unknown-participant`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipantsArray;
  }
}
